import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { Router } from '@angular/router';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { BoardOfTrusteesService } from '../../services/board-of-trustees-service';
import { AddBoardOfTrusteeComponent } from '../add-board-of-trustee/add-board-of-trustee.component';
import { BoardOfTrustees } from '../../models/board-of-trustees';
import { GetBoardOfTrusteeDetailsComponent } from '../get-board-of-trustee-details/get-board-of-trustee-details.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { DeleteConfirmationComponent } from '../../../delete-confirmation/delete-confirmation.component';

@Component({
  selector: 'app-get-board-of-trustees',
  templateUrl: './get-board-of-trustees.component.html',
  styleUrls: ['./get-board-of-trustees.component.scss'],
})
export class GetBoardOfTrusteesComponent extends BaseComponent implements OnInit {
  boardOfTrustees: BoardOfTrustees[] = [];

  form:FormGroup
  hasUnsavedChanges: boolean = false;
  originalOrder: BoardOfTrustees[] = [];
  isSaving: boolean = false;


  constructor(
    public service: BoardOfTrusteesService,
    route: Router,
    private fb: FormBuilder,
    private diag: NbDialogService,
    private toast: NbToastrService
  ) {
    super(route, service, null);
  }

  ngOnInit() {
    this.intitForm();
  this.getData()
  }



  getData ( searchTerm? ){
    this.service.getData('board-Of-trustees', searchTerm ? searchTerm : null ).subscribe(
      (res) => {
        this.boardOfTrustees = (res as any[]) || [];

        if (this.boardOfTrustees && this.boardOfTrustees.length > 0) {
          this.boardOfTrustees.sort((a: BoardOfTrustees, b: BoardOfTrustees) => {
            const aHas = typeof a.orderIndex === 'number' && a.orderIndex > 0;
            const bHas = typeof b.orderIndex === 'number' && b.orderIndex > 0;
            if (aHas && bHas) return (a.orderIndex as number) - (b.orderIndex as number);
            if (aHas && !bHas) return -1;
            if (!aHas && bHas) return 1;
            return 0;
          });
        }

        this.originalOrder = JSON.parse(JSON.stringify(this.boardOfTrustees));
        this.hasUnsavedChanges = false;
        this.finishLoading = true;
      },
      (err) => {
        console.log(err);
      }
    );
  }


  intitForm() {

    this.form = this.fb.group({
      titleAR: [''],
    })
      }


      handleSearch(){

    if(!this.form.value.titleAR){
        this.toast.danger('برجاءاختيار الاسم لاتمام عملية البحث', 'رساله تحذيرية');
        return
      }
      if(this.form.value.titleAR){

        this.getData(this.form.value.titleAR.trim())
      }
      }
    clearFilter(){

      this.form.controls['titleAR'].setValue('');
      this.getData()
    }


  addNew() {
    this.diag
      .open(AddBoardOfTrusteeComponent, {
        dialogClass: 'custom-dialog-height',
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.getData()
      });
  }

    delete(id) {
    this.diag.open(DeleteConfirmationComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        id: id,
        service: this.service,
        url:this.route.url
      },
    });
  }

  detail(model) {
    this.diag.open(GetBoardOfTrusteeDetailsComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        model: model,
      },
    });
  }

  update(model) {
    this.diag
      .open(AddBoardOfTrusteeComponent, {
        dialogClass: 'custom-dialog-height',
        context: {
          model: model,
          isEdit: true,
        },
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.getData()
      });
  }

  drop(event: CdkDragDrop<BoardOfTrustees[]>) {
    moveItemInArray(this.boardOfTrustees, event.previousIndex, event.currentIndex);
    this.boardOfTrustees.forEach((item: BoardOfTrustees, index: number) => {
      item.orderIndex = index + 1;
    });
    this.hasUnsavedChanges = true;
  }

  saveChanges() {
    if (!this.hasUnsavedChanges) {
      return;
    }

    this.isSaving = true;
    const members = this.boardOfTrustees.map((item: BoardOfTrustees) => {
      return {
        id: item.id,
        nameAR: item.nameAR,
        nameEN: item.nameEN,
        role: item.role,
        roleEn: item.roleEn,
        picPath: item.picPath,
        pic: item.pic,
        type: item.type,
        orderIndex: item.orderIndex
      };
    });

    this.service.putBulk(members, 'bulk').subscribe(
      () => {
        this.isSaving = false;
        this.hasUnsavedChanges = false;
        this.originalOrder = JSON.parse(JSON.stringify(this.boardOfTrustees));
        this.toast.show('تم حفظ تغييرات الترتيب بنجاح', '', { status: 'success', duration: 3000 });
      },
      (error) => {
        this.isSaving = false;
        console.error('Error updating order:', error);
        this.toast.show('حدث خطأ أثناء حفظ التغييرات', '', { status: 'danger', duration: 3000 });
      }
    );
  }
}
